import Loader from "@vfuk/core-loader";
import type { LoaderProps } from "@vfuk/core-loader/dist/Loader.types";

const SpinnerLoader = ({ text }: LoaderProps): JSX.Element => (
  <Loader size={2} appearance="primary" text={text} srText={text} />
);

export { SpinnerLoader };
